<template>
    <div>
        <div class="c-modal-in-the-wild">
            <div @click="toggleModal">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Modal from 'components/modal/Modal';
    import ModalContent from 'components/modal/ModalContent';

    export default {
        name: 'calculation-modal',
        components: {
            Modal,
            ModalContent,
        },
        props: {
            name: {
                required: true,
                type: String,
            },
            type: {
                required: true,
                type: String,
                default: 'lost'
            }
        },
        computed: {
            ...mapGetters('reserves/dayOneFatal', {
                fatalModal: 'modalPayload'
            }),
            ...mapGetters('reserves/dayOneLost', {
                lostModal: 'modalPayload'
            }),
        },
        methods: {
            ...mapActions('modal', ['toggle', 'getModalContent']),
            toggleModal() {
                this.toggle('calculation_modal');
                this.getModalContent({endpoint: this.name, payload: { args: this.type === 'lost' ? this.lostModal : this.fatalModal} });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// CalculationModal.vue?24fd07ba